import { franc, francAll } from 'franc';

// Detect ISO 639-3 language code from text. Returns 'und' if not confident.
export function detectLanguageIso3(text: string, minLength: number = 10): string {
    const clean = String(text ?? '').trim();
    if (clean.length < minLength) return 'und';
    try {
        return franc(clean);
    } catch {
        return 'und';
    }
}

// Return top N probable languages with scores
export function detectTopLanguages(text: string, topN: number = 5, minLength: number = 10): Array<[string, number]> {
    const clean = String(text ?? '').trim();
    if (clean.length < minLength) return [];
    try {
        const list = francAll(clean);
        return list.slice(0, topN);
    } catch {
        return [];
    }
}

// Map common ISO-639-3 to ISO-639-1 when possible (subset)
const ISO3_TO_ISO1: Record<string, string> = {
    eng: 'en',
    cmn: 'zh',
    zho: 'zh',
    spa: 'es',
    rus: 'ru',
    jpn: 'ja',
    kor: 'ko',
    fra: 'fr',
    deu: 'de',
    ita: 'it',
    por: 'pt',
    ara: 'ar',
    hin: 'hi',
    mar: 'mr',
    ben: 'bn',
    urd: 'ur',
};

export function iso3ToIso1(iso3: string): string | undefined {
    const key = String(iso3 ?? '').toLowerCase();
    return ISO3_TO_ISO1[key];
}

export function detectLanguageIso1(text: string): string | undefined {
    const iso3 = detectLanguageIso3(text);
    if (!iso3 || iso3 === 'und') return undefined;
    return iso3ToIso1(iso3);
}